import React from 'react';

import { Helmet } from 'react-helmet-async';
import { useIntl } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import ActionButton, { ActionButtonVariants } from 'components/action-button';
import useEffectOnce from 'hooks/use-effect-once';
import { CustomEventNames, EventTypes, useMParticleContext } from 'state/mParticle';
import { routes } from 'utils/routing';

import NotFoundImage from './not-found-image';
import { Content, NotFoundContainer } from './styled';

const ButtonContainer = styled.div`
  margin-bottom: 40px;
`;

const NotFound = () => {
  const { formatMessage } = useIntl();
  const navigate = useNavigate();
  const mParticle = useMParticleContext();

  useEffectOnce(() => {
    mParticle.logEvent(CustomEventNames.PAGE_NOT_FOUND, EventTypes.Other);
  });

  return (
    <div data-testid="page-not-found">
      <Helmet title={formatMessage({ id: 'pageNotFound' })} />
      <NotFoundContainer>
        <NotFoundImage />
        <Content>
          <h1>{formatMessage({ id: 'whoops' })}</h1>
          <p>{formatMessage({ id: 'pageMoved' })}</p>
          <ActionButton onClick={() => navigate(routes.base)}>
            {formatMessage({ id: 'goBack' })}
          </ActionButton>
          <ButtonContainer></ButtonContainer>
          <ActionButton variant={ActionButtonVariants.OUTLINE} onClick={() => navigate(0)}>
            {formatMessage({ id: 'tryAgain' })}
          </ActionButton>
        </Content>
      </NotFoundContainer>
    </div>
  );
};

export default NotFound;
